export default __webpack_public_path__ + "static/media/bajra.9d631f73.png";